import { AltWorkoutsPartComponent } from './AltWorkoutsPartComponent';

export default AltWorkoutsPartComponent;
